import type { FC } from 'react';

import { appConfig } from '../../../../../appConfig';
import type { BreadcrumbItem } from '../../../../common/components/molecules/Breadcrumbs';
import Breadcrumbs from '../../../../common/components/molecules/Breadcrumbs/Breadcrumbs';
import { buildAbsoluteUrl, buildSubSectionUrl } from '../../../utils/urlEcommerceUtils';
import type { SectionTreeItem } from '../../SectionMenu';

interface SectionBreadcrumbsProps {
    sectionTrail: SectionTreeItem[];
}

const SectionBreadcrumbs: FC<React.PropsWithChildren<SectionBreadcrumbsProps>> = (props) => {
    const breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'Handla',
            type: 'home',
            url: buildAbsoluteUrl(appConfig.coopSettings.ecommerce.url),
            isLayoutRouterAsyncLink: true,
        },
        ...(props.sectionTrail?.map((b, index) => ({
            name: b.name,
            type: 'category',
            url: buildAbsoluteUrl(buildSubSectionUrl(props.sectionTrail, index)),
            isLayoutRouterAsyncLink: false,
        })) || []),
    ];
    return <Breadcrumbs items={breadcrumbs} />;
};

export default SectionBreadcrumbs;
